import { Component, ElementRef, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { GfTitleService } from '../../../services/core.title.service';
import { SiteHelpService } from '../site-help.service';

/** The rendered manual page in the content panel of the site-help layout. Anonymous. */
@Component({
    selector: 'gf-site-help-page',
    template: require('./site-help-page.html')
})
export class SiteHelpPageComponent implements OnInit {
    loading = true;
    error: string | null = null;

    slug = '';
    content = '';

    constructor(
        private service: SiteHelpService,
        private stateService: StateService,
        private titleService: GfTitleService,
        private el: ElementRef
    ) { }

    ngOnInit() {
        this.slug = this.stateService.params.page;
        this.service.lastPage = this.slug;

        this.service.getPage(this.slug)
            .then((page) => {
                this.content = page.content;
                this.titleService.setTitle(page.title, 'Help');
                this.loading = false;
            })
            .catch((err) => {
                this.error = err && err.status === 404
                    ? 'This help page does not exist.'
                    : 'The help manual is not available right now.';
                this.titleService.setTitle('Help');
                this.loading = false;
            });
    }

    open(slug: string) {
        this.stateService.go('home.site-help.page', { page: slug });
    }

    /**
     * Rendered pages link to `/site-help/<slug>`, which is also the route URL.
     * As plain anchors inside rendered Markdown they would reload the whole
     * app, so route those clicks through the state service instead. Other
     * links (external, in-page anchors) are left alone.
     */
    onContentClick(event: MouseEvent) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) {
            return;
        }
        const anchor = (event.target as HTMLElement).closest('a');
        if (!anchor || !this.el.nativeElement.contains(anchor)) {
            return;
        }
        const slug = SiteHelpService.slugFromUrl(anchor.getAttribute('href') || '');
        if (slug) {
            event.preventDefault();
            this.open(slug);
        }
    }
}
